import { $, $$ } from 'utils/dom';
import Slider from 'modules/glide/glide';

const gridSliders = $$('.page-slider');

if (gridSliders.length) {
  gridSliders.forEach(gridSlider => {
    const pageSliderItems = $$('.page-slider__item', gridSlider);
    const slider = new Slider($('.glide', gridSlider), {
      config: {
        type: 'carousel',
        startAt: 0,
        perView: 1,
        controls: true,
        bullets: true,
        bound: true,
        gap: 45,
        events: [
          {
            event: ['mount.after'],
            handler: () => {
              const sliderFigures = $$('.page-slider__figure', gridSlider);
              const imageLoaded = (sliderImage, sliderFigure) => {
                const imageWidth = sliderImage.getBoundingClientRect().width;
                sliderFigure.style.width = `${imageWidth}px`;
              };
              sliderFigures.forEach(sliderFigure => {
                const sliderImage = $('.page-slider__image', sliderFigure);
                if (sliderImage.complete) {
                  imageLoaded(sliderImage, sliderFigure);
                } else {
                  sliderImage.addEventListener('load', () =>
                    imageLoaded(sliderImage, sliderFigure)
                  );
                }
                window.addEventListener('resize', () => {
                  sliderFigure.removeAttribute('style');
                  imageLoaded(sliderImage, sliderFigure);
                });
              });
            },
          },
        ],
      },
    });

    if (pageSliderItems.length > 1) slider.init();
  });
}
